// extracted by mini-css-extract-plugin
export default {"root":"styles_root__00I63","bg":"styles_bg__cKLSE","container":"styles_container__t9U5b"};